<template>
  <!-- 运单信息 -->
  <div>
    <!-- 头部-->
    <div class="city-child-head">
      <!-- 标题 -->
      <div class="city-child-head-left float-l">
        <div class="city-child-head-icon"></div>
        <span>异常信息</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="city-content city-content-chunk-box">
      <div class="city-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>
<script>
import { getOperateList } from '../../api/holdMy.js';
export default {

  data() {
    return {
      refreshImgIng: null,   // 刷新定时器
      getData: {
        cityName: this.$route.query.cityName,
        city: this.$route.query.cityName,
      },
      config: {
        header: ['时间', '车牌/运单', '异常'],
        data: [],
        rowNum: 6, //表格行数
        headerHeight: 27,
        headerBGC: 'rgba(0,144,255,0.2)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'left', 'left'],
        columnWidth: [60, 90],
      },
    }
  },
  components: {},
  created() {

  },
  mounted() {
    this.refreshScale();
  },

  beforeDestroy() {
    clearInterval(this.refreshImgIng);
  },
  methods: {
    // 刷新数据
    refreshScale() {
      this.operateList();
      this.refreshImgIng = setInterval(() => {
        this.operateList();
      }, 1000 * 60 * 30)
    },
    // 获取运营消息
    operateList() {
      let that = this;
      getOperateList({ ...this.getData }).then(res => {
        if (res.result == 0) {
          let userdata = res.userdata;
          var data1 = [];
          userdata.forEach(element => {
            data1.push([`<span style="color:rgba(255, 255, 255, 0.4980392156862745);">${element.receiveOrderTime ? element.receiveOrderTime : ""}</span>`,
            `<span><div>${element.carNum ? element.carNum : ""}</div><div>${element.orderNo ? element.orderNo : ""}</div></span>`,
            `<span class="box2">${element.remark ? element.remark : ""}</span>`]);
          });
          that.config.data = data1;
          that.config = { ...that.config };//关键,展开数组对象重新赋值.不写数据出不来
        }
      }).catch(error => {
        console.log(error);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
  height: 283px;
  overflow: hidden;

  .city-box {
    padding: 0px;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
}

::v-deep .dv-scr-board .rows .ceil {
  line-height: 18px;
  white-space: wrap;
  display: flex;
  align-items: center;

  .box2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
